// Add class to body on scroll
import Swiper from 'swiper/bundle';

const swiper = new Swiper('.swiper-latest', {
    effect: 'fade',
    autoplay: {
        delay: 3000,
    },
    fadeEffect: {
        crossFade: true
    },
});

function NavOnScroll() {
    jQuery(window).on('scroll', function () {
        var scroll = jQuery(window).scrollTop();
        if (scroll >= 100) {
            jQuery("body").addClass("scrolled");
        } else {
            jQuery("body").removeClass("scrolled");
        }
    });
}
NavOnScroll()

// Mobile menu toggle

function MobileMenu() {
    jQuery("body").on('click', '.menu-toggle', function () {
        jQuery('.menu-toggle').toggleClass('toggle-open');
        jQuery('.mobile-menu').toggleClass('mobile-menu-open');
    });

    jQuery("body").on('click', '.uzp__allfilters', function () {
        jQuery('.uzp__filters').toggleClass('is-open');
    });

    jQuery("body").on('click', '.mobile-menu .menu-item-has-children', function () {
        jQuery(this).find('ul.sub-menu').toggleClass('sub-menu-open');
        jQuery(this).toggleClass('item-is-open');
    });
}
MobileMenu()



